// Deterministic id for a budget-derived recap row.
//
// The same logical recap row (one budget line of one quote) MUST resolve to the
// same id whether it is created by this client or by the masterQuote Lambda.
// The AppSync `createRecapInfo` resolver enforces `attribute_not_exists(id)`, so
// when two creators race for the same budget line they compute an identical id
// and the second create is rejected by DynamoDB — duplicates become impossible.
//
// IMPORTANT: this function must stay byte-identical to its server twin at
// `amplify/backend/function/masterQuote/ts/syncRecapInfo/recapInfo/getDeterministicRecapId.ts`
// (the Lambda tsconfig cannot import from `src/`). It is a plain composite
// string — no uuid, no namespace constant — precisely so the two copies are
// trivially verifiable as identical. Only ever used for budget-derived rows
// (uuid = budget line id); custom cost lines keep random ids.
export function getDeterministicRecapId(quoteId: string, budgetLineId: string) {
	return `recap#${quoteId}#${budgetLineId}`
}
